import React from 'react';
import clsx from 'clsx';
import {
	composeClasses,
	styled,
	type WithClasses,
} from '@netx/core-components/Theme';
import {
	formFooterClasses,
	getFormFooterUtilityClass,
	FORM_FOOTER_CLASS_NAME,
	type FormFooterClasses,
} from './formFooterClasses';

export type FormFooterOwnerState = WithClasses<FormFooterClasses>;

const useUtilityClasses = (ownerState: FormFooterOwnerState) => {
	const {classes} = ownerState;
	const slots = {
		root: ['root'],
	};
	return composeClasses(slots, getFormFooterUtilityClass, classes);
};

const FormFooterRoot = styled('div', {
	name: FORM_FOOTER_CLASS_NAME,
	slot: 'Root',
})(({theme}) => ({
	padding: theme.spacing(2),
	flex: '0 0 auto',
	display: 'flex',
}));

export interface FormFooterProps
	extends React.DetailedHTMLProps<
			React.HTMLAttributes<HTMLDivElement>,
			HTMLDivElement
		>,
		WithClasses<FormFooterClasses, React.PropsWithChildren> {}

export const FormFooterPrimitive = ({
	classes: _classes,
	className,
	children,
	...props
}: FormFooterProps) => {
	const ownerState: FormFooterOwnerState = {
		classes: _classes,
		className,
	};

	const classes = useUtilityClasses(ownerState);

	return (
		<FormFooterRoot className={clsx(classes.root, className)} {...props}>
			{children}
		</FormFooterRoot>
	);
};

export const FormFooter = FormFooterPrimitive;

export default FormFooter;
